<template>
  <div class="register-box">
    <div class="register-content">
      <i class="title-register" />
      <template v-if="show === 'success'">
        <i class="icon-success" />
        <span class="response-title">注册成功</span>
        <span class="response-tip">恭喜您已成功注册为开发者</span>
        <el-button
          class="btn-submit"
          type="primary"
          @click="goLogin"
        >
          去登录（{{ time }}s）
        </el-button>
      </template>
      <template v-else-if="show === 'error'">
        <i class="icon-error" />
        <span class="response-title">注册失败</span>
        <span class="response-tip">{{ message }}</span>
        <span>
          <el-button
            class="btn-back"
            @click="goHome"
          >
            返回首页
          </el-button>
          <el-button
            class="btn-submit back"
            type="primary"
            @click="goForm"
          >
            返回上一步
          </el-button>
        </span>
      </template>
      <template v-else>
        <span
          v-for="item in formItems"
          :key="item.key"
          class="input-item"
        >
          <label>{{ item.label }}</label>
          <el-input
            v-model="formValue[item.key]"
            placeholder="--"
            disabled
            class="register-input"
          />
        </span>
        <span class="tips">请注意核对信息</span>
        <el-button
          class="btn-submit"
          type="primary"
          :loading="submitting"
          :disabled="!loaded"
          @click="submit"
        >
          注册成为开发者
        </el-button>
      </template>
    </div>
  </div>
</template>
<script>
import { getDevInfo, submitDevInfo } from '@/service';

export default {
  data() {
    return {
      show: 'form',
      message: '',
      time: 3,
      loaded: false,
      submitting: false,
      disposed: false,
      countdownTimer: null,
      formItems: [
        {
          key: 'account_type_name',
          label: '账户类型',
        },
        {
          key: 'account_id',
          label: '账户ID',
        },
        {
          key: 'account_name',
          label: '账户名称',
        },
        {
          key: 'company',
          label: '公司名称',
        },
        {
          key: 'phone',
          label: '手机号',
        },
        {
          key: 'license_code',
          label: '信用代码',
        },
        {
          key: 'email',
          label: '邮箱',
        },
      ],
      formValue: {},
    };
  },
  created() {
    this.getDevInfo();
  },
  beforeDestroy() {
    this.disposed = true;
    clearTimeout(this.countdownTimer);
  },
  methods: {
    async getDevInfo() {
      try {
        const res = await getDevInfo(false);
        if (this.disposed) return;
        if (res.code === 200 && res.data) {
          this.formValue = res.data;
          this.loaded = true;
        } else {
          this.message = res.message || '账户资料加载失败，请重试';
          this.show = 'error';
        }
      } catch (e) {
        if (this.disposed) return;
        this.message = e.message || '账户资料加载失败，请重试';
        this.show = 'error';
      }
    },
    goForm() {
      this.show = 'form';
      if (!this.loaded) this.getDevInfo();
    },
    goHome() {
      this.$router.push({ name: 'home' });
    },
    goLogin() {
      clearTimeout(this.countdownTimer);
      this.$router.push({ name: 'Login' });
    },
    subTime() {
      if (this.disposed) return;
      if (this.time <= 0) {
        this.goLogin();
      } else {
        this.countdownTimer = setTimeout(() => {
          this.time -= 1;
          this.subTime();
        }, 1000);
      }
    },
    async submit() {
      if (!this.loaded || this.submitting || this.show !== 'form') return;
      this.submitting = true;
      try {
        const res = await submitDevInfo();
        if (this.disposed) return;
        if (res.code === 200) {
          this.show = 'success';
          this.subTime();
        } else {
          this.message = res.message || '注册失败，请稍后重试';
          this.show = 'error';
        }
      } catch (e) {
        if (this.disposed) return;
        this.message = e.message || '注册失败，请稍后重试';
        this.show = 'error';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss">
.mod-layout {
  &.page-developerregister {
    .layout-header {
      .btn-link-box {
        position: relative;
        &.register {
          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 8px;
            margin-top: -8px;
            background-color: #3f90f7;
            border-radius: 999px;
            z-index: 1;
          }
        }
      }
    }
    .register-input {
      flex-shrink: 1;
      .el-input__inner {
        background-color: transparent;
        border: none;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.page-developerregister {
  .register-box {
    width: 100%;
    padding: 90px 0;
    .register-content {
      margin: 0 auto;
      padding: 60px 0;
      width: 800px;
      height: 600px;
      background: #fff;
      box-shadow: 0px 4px 20px rgba(16, 117, 229, 0.2);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title-register {
        display: inline-block;
        width: 345px;
        height: 41px;
        margin-bottom: 22px;
        background-image: url('../Register/images/title_register.png');
      }
      .input-item {
        display: flex;
        justify-content: space-between;
        width: 368px;
        height: 40px;
        box-sizing: border-box;
        padding: 0 16px;
        margin-top: 20px;
        background: #f5f7fa;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        > label {
          flex-shrink: 0;
          font-family: Noto Sans SC;
          font-size: 14px;
          line-height: 40px;
          color: #909399;
        }
      }
      .btn-submit {
        width: 400px;
        height: 40px;
        margin-top: 16px;
        &.back {
          width: 190px;
        }
      }
      .tips {
        margin-top: 16px;
        font-family: Noto Sans SC;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #ffb046;
      }
      .icon-success {
        display: inline-block;
        width: 72px;
        height: 72px;
        margin-top: 106px;
        background-image: url('../Register/images/icon_success.png');
      }
      .icon-error {
        display: inline-block;
        width: 72px;
        height: 72px;
        margin-top: 106px;
        background-image: url('../Register/images/icon_error.png');
      }
      .response-title {
        margin-top: 24px;
        font-family: Noto Sans SC;
        font-weight: bold;
        font-size: 24px;
        line-height: 35px;
        color: rgba(0, 0, 0, 0.8);
      }
      .response-tip {
        margin-top: 14px;
        font-family: Noto Sans SC;
        font-size: 14px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.4);
      }
      .btn-back {
        width: 190px;
        height: 40px;
        color: #3f90f7;
        border: 1px solid #3f90f7;
      }
    }
  }
}
</style>
